import { ViewModel,View } from "binder"
import  { FontStyleEditorView } from "./fontStyleEditor-view"
import { IStaticValueProvider } from "../IStaticValueProvider";
import { SelectorBaseViewModel } from "src/common/reusableComponents/selectorBase/selectorBase-viewModel";
import { stringIsNullOrEmpty } from "src/common/utilities";

export class FontStyleEditorViewModel extends ViewModel implements IStaticValueProvider{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        
        this.fontStyleSelector = new FontStyleCombo(this);
        this.fontStyleSelector.onSelectionChanged = x=>this.selectedFontStyle = x;

    }
    public set fontStyleSelector(v: FontStyleCombo) { this._fontStyleSelector = v; } public get fontStyleSelector(): FontStyleCombo { return this._fontStyleSelector;} private _fontStyleSelector: FontStyleCombo;
    public set selectedFontStyle(v: singleStyle) { this._selectedFontStyle = v; } public get selectedFontStyle(): singleStyle { return this._selectedFontStyle;} private _selectedFontStyle: singleStyle;
    
    
    setValue(v: string) {
        if(stringIsNullOrEmpty(v))
            this.fontStyleSelector.selectById(null);
        else 
            this.fontStyleSelector.selectById(v);
    }
    getValue(): string {
        return this.selectedFontStyle?.id ?? '';
    }
    requestConfirm() {
    }
    GetDefaultView(): View <ViewModel> {
        return new FontStyleEditorView();
    }
    public getTypeId(): string {
        return "VM-B2C014AE-D6BD-4D8D-9AB6-37ABB94E9453"
    }
}
export class FontStyleCombo extends SelectorBaseViewModel<singleStyle>{
    protected loadData(): Promise<singleStyle[]> {
        let result:singleStyle[] = [
            new singleStyle(this,'italic','italic'),
            new singleStyle(this,'normal','normal'),
            new singleStyle(this,'oblique','oblique'),
        ];
        return Promise.resolve<singleStyle[]>(result);
    }

}
export class singleStyle extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel,id:string,name:string) {
        super(parent);
        
        this.id = id;
        this.title = name;
    }
    
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
    
}